import { Order, PackageDetail, PackageInformation } from "src/models";
import { PackagesType } from "../types";
import { createAction } from "./create.action";

export namespace PackagesAction {
    export const showLoading = () => createAction(PackagesType.SHOW_PACKAGES_LOADING);
    export const hideLoading = () => createAction(PackagesType.HIDE_PACKAGES_LOADING);
    export const clear = () => createAction(PackagesType.CLEAR_PACKAGE_STATE);
    export const clearDetail = () => createAction(PackagesType.CLEAR_PACKAGE__DETAIL_STATE);

    export const createOrder = (packageProfileId: number, programId?: number) => createAction(PackagesType.REQUEST_CREATE_ORDER, { programId, packageProfileId });
    export const requestOrderInfo = (orderId: number) => createAction(PackagesType.REQUEST_ORDER_INFO, orderId);
    export const setOrderInfo = (order: Order) => createAction(PackagesType.SET_ORDER_INFO, order);

    export const addDiscount = (orderId: number, code: string) => createAction(PackagesType.ADD_DISCOUNT_CODE, { orderId, code });
    export const removeDiscount = (orderId: number) => createAction(PackagesType.REMOVE_DISCOUNT_CODE, { orderId });

    export const pay = (orderId: number, bankType: number, payUrl: string) => createAction(PackagesType.PAY_ORDER, { model: { orderId, bankType }, payUrl });

    export const sendSms = (url: string) => createAction(PackagesType.SEND_VAS_SMS, url);
    export const SmsSent = () => createAction(PackagesType.VAS_SMS_SENT);
    export const verifySms = (url: string, code: string, programId: number) => createAction(PackagesType.VERIFY_VAS_SMS, { url, code, programId });

    export const sendGiftCode = (code: string) => createAction(PackagesType.SEND_GIFT_CODE, code);
    export const giftCodeSent = (success: boolean) => createAction(PackagesType.GIFT_CODE_SENT, success);

    export const requestPackages = (clear: boolean) => createAction(PackagesType.REQUEST_PACKAGES, clear);
    export const setPackages = (packages: PackageInformation[]) => createAction(PackagesType.SET_PACKAGES, packages);

    export const requestPackageDetail = (id: number) => createAction(PackagesType.REQUEST_PACKAGE_DETAIL, id);
    export const setPackageDetail = (packageDetail: PackageDetail) => createAction(PackagesType.SET_PACKAGE_DETAIL, packageDetail);
}